import React from "react";
import { getTranslatedKey } from "../../../utils/commonfunction";
import type { SpiceOption } from "./SetMenuAddonPicker";

const translated = (key: string, data: unknown): string =>
  getTranslatedKey(key, data as never);

interface Props {
  options: SpiceOption[];
  /** Unit count to print beside a level, keyed by its id. Absent = no count. */
  counts?: Record<string, number>;
  onPick: (spice: SpiceOption) => void;
  /**
   * The level currently held, where the chips are a standing choice rather
   * than a one-tap answer. Left unset — the set picker's prompt — nothing shows
   * as chosen, because a preselected level is a default nobody typed.
   */
  selectedId?: string | null;
  /** Distinguishes the radio group when two chip rows share a page. */
  name?: string;
}

/**
 * The spice levels as a row of pills.
 *
 * One implementation for both places a level is ever asked for: the set
 * picker's prompt, and the plain dialog for an item that needs a level and has
 * no components. They looked different when they were two chunks of markup.
 */
const SpiceLevelChips = ({
  options = [],
  counts,
  onPick,
  selectedId = null,
  name = "spice_level_chips",
}: Props) => (
  <div className="set-addon-prompt-chips">
    <ul>
      {options.map((spice) => {
        const count = counts?.[String(spice?._id)];
        return (
          <li key={spice._id}>
            <div className="check-input-tick">
              <input
                type="radio"
                className="cp"
                name={name}
                id={`${name}_${spice._id}`}
                value={spice._id}
                checked={String(spice?._id) === String(selectedId)}
                onChange={() => onPick(spice)}
              />
              <label htmlFor={`${name}_${spice._id}`} className="cp">
                {translated("name", spice) || spice?.name}
                {count ? ` ×${count}` : ""}
              </label>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

export default SpiceLevelChips;
